import { ApiTicket, GndSpecificData } from '../../types';
import { getFormMapper, GndCategory, AnswerData } from '../../utils/formMapper';

function buildAnswersData(apiTicket: ApiTicket): AnswerData[] {
  return apiTicket.answers?.map(answer => ({
    questionTranslationKey: answer.question.questionTranslationKey,
    answer: answer.answer,
    selectedOption: answer.selectedOption
  })) || [];
}

function buildGndSpecificData(extractedFields: Record<string, string>, category: GndCategory): GndSpecificData {
  const gndData: GndSpecificData = {};

  switch (category) {
    case 'youAreGiving':
      gndData.typeOfRecipient = extractedFields['Type of Recipient'] || 'N/A';
      gndData.typeOfGift = extractedFields['Type of Gift'] || 'N/A';
      gndData.totalAmountInUsd = extractedFields['Total Amount in USD'] || 'N/A';
      break;

    case 'youAreReceiving':
      gndData.typeOfProvider = extractedFields['Type of Provider'] || 'N/A';
      gndData.typeOfGift = extractedFields['Type of Gift'] || 'N/A';
      gndData.totalAmountInUsd = extractedFields['Total Amount in USD'] || 'N/A';
      break;

    case 'officeInternalUsage':
      gndData.totalAmountInUsd = extractedFields['Total Amount in USD'] || 'N/A';
      break;

    default:
      break;
  }

  gndData.companyName = extractedFields['Company Name'];
  gndData.description = extractedFields.Description;
  gndData.extractedFields = extractedFields;
  gndData.detectedFields = Object.keys(extractedFields);

  return gndData;
}

export function generateGndDescription(apiTicket: ApiTicket, category: GndCategory): string {
  if (apiTicket.approvalComments?.trim()) {
    return apiTicket.approvalComments;
  }

  const formTypeName = apiTicket.formType.name || 'Gifts & Donations';
  const zone = apiTicket.requestedBy.zone?.name || 'unknown zone';

  let categoryText = '';
  switch (category) {
    case 'youAreGiving':
      categoryText = 'giving';
      break;
    case 'youAreReceiving':
      categoryText = 'receiving';
      break;
    case 'officeInternalUsage':
      categoryText = 'office internal usage';
      break;
    default:
      categoryText = 'compliance matter';
  }

  return `${formTypeName} (${categoryText}) declared by employee in the ${zone}.`;
}


export function mapGndSpecificData(apiTicket: ApiTicket, category: GndCategory): GndSpecificData {
  const gndMapper = getFormMapper('gnd');
  
  if (!gndMapper) {
    return {};
  }

  const answersData = buildAnswersData(apiTicket);
  const extractedFields = gndMapper.extractFields(answersData, category);
  
  return buildGndSpecificData(extractedFields, category);
}